import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  catalogues: function catalogues(state) {
    return state.lookbook.lookbooks;
  },
  ambiences: function ambiences(state) {
    return state.lookbook.items;
  },
  attributes: function attributes(state) {
    return state.lookbook.attributes;
  },
  loadingAmbiences: function loadingAmbiences(state) {
    return state.loading;
  },
  current: function current(state) {
    return state.current;
  }
};